<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('code.notice')}}</div>
        </div>
        <div id="notice" class="cotainer">
            <div class="cont" v-html="content"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'notice',
    data () {
        return {
          theme: false,
          id: '',
          content: ''
        }
    },
    created(){
        this.id = this.$route.query.id;
        this.theme = JSON.parse(localStorage.getItem('theme'))
    },
    mounted() {
        this.getNotice()
    },
    methods: {
       back(){
           this.$router.push('/index')
       },
       getNotice(){
          let params = {
                  id: this.id,
                }
                this.$ajax.get('/web/getText',{params}).then((res) => {
                    let resData = res.data.data;
                    this.content = this.contHtml(resData.content);
                }).catch(function(err){
                    console.log(err)
                })
        },
        contHtml(str){
            str = str.replace(/&amp;/g, '&');
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            str = str.replace(/&quot;/g, "''");
            str = str.replace(/&#039;/g, "'");
            return str;
        },
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .cont{
        padding: .3rem;
        color: #7f7f7f;
        font-size: .42rem;
        word-break: break-all;
    }
    /* .cotainer .cont img{
      position: relative;
      max-width: 100%;
      left: 50%;
      transform: translateX(-50%);
    } */
</style>
<style>
  #notice .cont img{
    position: relative;
    max-width: 100%;
    left: 50%;
    transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/pages/notice.vue